import * as constants from './constants';
import {post} from "../../../utils/request";
import {ORDER_QUERY, ORDER_CREATE_PAGE, ORDER_CREATE_PAY} from '../../../utils/api';
import axios from 'axios';


export const OrderDetail = (Entity) => ({
    type: constants.ORDER_QUERY,
    value: Entity
});

export const getPayParams = (params) => {
    return async (dispatch) => {
        const result = await getWechatParams(params);
        return result;
    }
};

export const getOrderDetail = (params) => {
    return (dispatch) => {
        return post(ORDER_QUERY + "/" + params.orderId, params)
            .then((response) => {
                return dispatch(OrderDetail(response.data));
            });
    }
};

export const createOrderPage = (params) => {
    return async (dispatch) => {
        return post(ORDER_CREATE_PAGE, params)
            .then((response) => {
                return dispatch(OrderDetail(response.data.result));
            });
    }
};

export const createOrder = (params) => {
    return async (dispatch) => {
        const result = await getWechatParams(params);
        return result;
    }
};

const getWechatParams = (params) => {
    let token = Storage.Base.getInstance().get('_loginTk');
    if (!token) {
        token = "";
    }
    return axios({
        method: 'post',
        url: ORDER_CREATE_PAY,
        data: JSON.stringify(params),
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'token': token
        },
        timeout: 3000
    })
        .then(response => {
            return response;
        });
};
